import { format } from 'date-fns';
import { ChevronDownIcon } from 'lucide-react';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { cn } from '../../lib/utils';
import { Button } from '../../ui/button';
import { Calendar } from '../../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';

interface ControlledDatePickerProps {
  name: string;
  placeholder?: string;
  className?: string;
}

export function ControlledDatePicker({
  name,
  placeholder = 'Select date',
  className,
}: ControlledDatePickerProps) {
  const { control } = useFormContext();
  const [open, setOpen] = React.useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className={cn(
                'w-full justify-between font-normal text-left',
                !field.value && 'text-muted-foreground',
                className
              )}
            >
              {field.value instanceof Date && !isNaN(field.value.getTime())
                ? format(field.value, 'PPP')
                : field.value && typeof field.value === 'string'
                  ? format(new Date(field.value), 'PPP')
                  : placeholder}
              <ChevronDownIcon className="ml-2 h-4 w-4 opacity-50" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              style={{ minWidth: '200px' }}
              selected={field.value ? new Date(field.value) : undefined}
              onDayClick={(date) => {
                field.onChange(date);
                setOpen(false);
              }}
              onSelect={(date) => {
                field.onChange(date);
                setOpen(false);
              }}
            />
          </PopoverContent>
        </Popover>
      )}
    />
  );
}
